import { __assign, __rest } from "tslib";
import * as React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
export var BbTooltip = function (props) {
    var disableArrow = props.disableArrow, isCustomTitle = props.isCustomTitle, PopperProps = props.PopperProps, other = __rest(props, ["disableArrow", "isCustomTitle", "PopperProps"]);
    if (isCustomTitle) {
        return (React.createElement(Tooltip, __assign({ "aria-describedby": undefined, enterTouchDelay: 0, arrow: !disableArrow, PopperProps: __assign({ 'aria-hidden': true }, PopperProps) }, other)));
    }
    return React.createElement(Tooltip, __assign({ enterTouchDelay: 0, arrow: !disableArrow, PopperProps: PopperProps }, other));
};
export default BbTooltip;
//# sourceMappingURL=Tooltip.js.map